import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { ErrorInterceptor } from './app/core/helpers/error.interceptor';
import { AuthInterceptor } from './app/core/helpers/auth.interceptor';
import { EventInterceptor } from './app/core/helpers/event.interceptor';
import { PermissionsInterceptor } from './app/core/helpers/permission.interceptor';
import { NotificationInterceptor } from './app/core/helpers/notification.interceptor';
import * as Sentry from '@sentry/angular';
import { APP_VERSION } from './app/core/services/version.service';


async function getAppVersion(): Promise<string> {
  try {
    const res = await fetch(`${environment.backend_web}api/app-version`, {
      credentials: 'include', // optional
      cache: 'no-store',      // or allow caching if you set cache headers
    });

    if (!res.ok) return 'unknown';
    const response = await res.json();
    return response.data?.version ?? 'unknown';
  } catch {
    return 'unknown';
  }
}

// Enable production mode if in production environment

(async () => {

  const appVersion = await getAppVersion();
  if (environment.env !== "local") {

    // enableProdMode();
    Sentry.init({
      dsn: environment.sentry.dsn,
      environment: environment.sentry.environment,
      release: `${appVersion}-${environment.env ?? ''}`,

      // Replay (newer SDKs often recommend the integration helper)
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,
        }),
      ],

      ignoreErrors: ['ResizeObserver loop completed with undelivered notifications.'],

      // Performance Monitoring
      tracesSampleRate: 0, // same as your config

      // Session Replay sampling
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('combined-sw.js')
        .then(reg => {
          // console.log('Service Worker registered manually:', reg);
          return navigator.serviceWorker.ready;
        })
        .then(readyReg => {
          // console.log('Service Worker is ready:', readyReg);
        })
        .catch(err => {
          // console.error('Service Worker registration or readiness failed:', err);
        });
  }

  await bootstrapApplication(AppComponent, {
    providers: [
      provideHttpClient(),
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      // { provide: HTTP_INTERCEPTORS, useClass: EventInterceptor, multi: true }, //Call to handle success realated stuff
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: PermissionsInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: NotificationInterceptor, multi: true },
      { provide: APP_VERSION, useValue: appVersion },

      ...appConfig.providers,
    ]
  })

})().catch((err) => console.error('Error during bootstrapping the application:', err));;